(function () {
  'use strict';

  function root() {
    try {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    } catch (e) {}
    return '/';
  }

  function cartUrl(path) {
    var r = root();
    if (r.slice(-1) !== '/') r += '/';
    return r + String(path).replace(/^\//, '');
  }

  function fixCartUrl(url) {
    if (url == null) return url;
    var s = String(url);
    if (
      s === 'cart' ||
      s === 'cart.js' ||
      s === './cart' ||
      s === './cart.js' ||
      s === '/products/cart' ||
      s === '/products/cart.js' ||
      /\/products\/[^/?#]+\/cart(\.js)?(\?|#|$)/.test(s)
    ) {
      return cartUrl('cart/add.js');
    }
    return url;
  }

  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      if (typeof input === 'string') input = fixCartUrl(input);
      else if (input && typeof Request !== 'undefined' && input instanceof Request) {
        var fixed = fixCartUrl(input.url);
        if (fixed !== input.url) input = new Request(fixed, input);
      }
    } catch (e) {}
    return _fetch.call(this, input, init);
  };

  var variantMap = null;
  function loadVariantMap() {
    if (variantMap) return variantMap;
    variantMap = {};
    document.querySelectorAll('script[type="application/json"]').forEach(function (el) {
      try {
        var data = JSON.parse(el.textContent);
        var variants = data && (data.variants || (data.product && data.product.variants));
        if (!variants || !variants.length) return;
        variants.forEach(function (v) {
          if (v.id && v.title) variantMap[String(v.title).trim()] = Number(v.id);
          if (v.id && v.option1) variantMap[String(v.option1).trim()] = Number(v.id);
          if (v.id) variantMap[String(v.id)] = Number(v.id);
        });
      } catch (e) {}
    });
    return variantMap;
  }

  function fetchProductJs() {
    loadVariantMap();
    if (Object.keys(variantMap).length) return Promise.resolve();
    var handleMatch = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!handleMatch) return Promise.resolve();
    return fetch(root().replace(/\/?$/, '/') + 'products/' + handleMatch[1] + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (d) {
        variantMap = variantMap || {};
        (d.variants || []).forEach(function (v) {
          if (v.id && v.title) variantMap[String(v.title).trim()] = Number(v.id);
          if (v.id && v.option1) variantMap[String(v.option1).trim()] = Number(v.id);
          variantMap[String(v.id)] = Number(v.id);
        });
      })
      .catch(function () {});
  }

  function resolveVariantId(raw) {
    if (raw == null || raw === '') return null;
    var s = String(raw).trim().replace(/\s*-\s*Unavailable\s*$/i, '').trim();
    if (/^\d+$/.test(s)) return Number(s);
    var map = loadVariantMap();
    if (map[s]) return map[s];
    var lower = s.toLowerCase();
    for (var k in map) {
      if (k.toLowerCase() === lower) return map[k];
    }
    return null;
  }

  function enableVariantInputs(rootEl) {
    (rootEl || document).querySelectorAll('input.product-variant-id, input[name="id"]').forEach(function (inp) {
      inp.disabled = false;
      inp.removeAttribute('disabled');
    });
    (rootEl || document).querySelectorAll('[data-skip-cart="true"]').forEach(function (el) {
      el.setAttribute('data-skip-cart', 'false');
    });
  }

  function getSelectedPack(sectionRoot) {
    var qb =
      (sectionRoot && (sectionRoot.querySelector('quantity-breaks') || sectionRoot.querySelector('.quantity-breaks'))) ||
      document.querySelector('quantity-breaks, .quantity-breaks');
    if (!qb) return null;
    var checked = qb.querySelector('input[type="radio"]:checked');
    if (!checked) {
      var active = qb.querySelector('.quantity-break--selected, .quantity-break.is-selected');
      if (active) checked = active.querySelector('input[type="radio"]') || active;
    }
    if (!checked) return null;
    var pack = checked.closest('.quantity-break') || checked.closest('[data-quantity]') || checked;
    var qty = parseInt(pack.getAttribute('data-quantity') || checked.getAttribute('data-quantity') || '1', 10);
    if (!qty || qty < 1) qty = 1;

    var ids = [];
    pack.querySelectorAll('.quantity-break__selector-item').forEach(function (item) {
      var id = null;
      var sel = item.querySelector('select.quantity-break__variant-select, select');
      if (sel) {
        var opt = sel.options[sel.selectedIndex];
        if (opt) id = resolveVariantId(opt.getAttribute('data-variant-id') || opt.value || opt.text);
        if (!id) id = resolveVariantId(sel.value);
      }
      if (!id) id = resolveVariantId(item.getAttribute('data-selected-id') || item.getAttribute('data-product-id'));
      if (id) ids.push(Number(id));
    });

    if (!ids.length) {
      var formId = checked.getAttribute && checked.getAttribute('form');
      var form = formId ? document.getElementById(formId) : null;
      if (!form && sectionRoot) form = sectionRoot.querySelector('form[action*="cart"]');
      if (!form) form = document.querySelector('form[data-type="add-to-cart-form"]');
      var master = form && form.querySelector('input[name="id"]');
      var mid = master && resolveVariantId(master.value);
      if (mid) ids.push(Number(mid));
    }

    return { qty: qty, ids: ids };
  }

  /**
   * Packs: use pack quantity + first variant by default (Buy 2 = qty 2).
   * Only split into multiple lines if the customer picked DIFFERENT variants per slot.
   */
  function buildCartItems(packInfo, fallbackId, fallbackQty) {
    var fallback = resolveVariantId(fallbackId);

    if (packInfo && packInfo.ids && packInfo.ids.length) {
      var unique = [];
      packInfo.ids.forEach(function (id) {
        if (unique.indexOf(id) === -1) unique.push(id);
      });

      // Different variants chosen in the pack slots
      if (unique.length > 1 && packInfo.ids.length > 1) {
        var counts = {};
        packInfo.ids.forEach(function (id) {
          counts[id] = (counts[id] || 0) + 1;
        });
        return Object.keys(counts).map(function (id) {
          return { id: Number(id), quantity: counts[id] };
        });
      }

      // Same variant (or only one resolved) → one line, pack qty
      return [{ id: Number(packInfo.ids[0]), quantity: packInfo.qty || 1 }];
    }

    return [{ id: Number(fallback), quantity: fallbackQty || 1 }];
  }

  function syncMasterIdFromPack(form) {
    if (!form) return;
    var section = form.closest('.shopify-section, .featured-product, product-info, .product') || document;
    var packInfo = getSelectedPack(section);
    var idInp = form.querySelector('input[name="id"], input.product-variant-id');
    if (!idInp) return;
    if (packInfo && packInfo.ids && packInfo.ids[0]) idInp.value = String(packInfo.ids[0]);
    idInp.disabled = false;
    idInp.removeAttribute('disabled');
  }

  function inThemeEditor() {
    try {
      if (window.Shopify && Shopify.designMode) return true;
    } catch (e) {}
    if (window.location.search.indexOf('preview_theme_id') !== -1) return true;
    if (/\/admin\//.test(window.location.href) && /editor|theme/.test(window.location.href)) return true;
    return false;
  }

  // NEVER use items[] HTML form (causes "Required parameter missing or invalid: items").
  // Single line: GET /cart/add?id=&quantity= (cookie-safe).
  // Multi different variants: JSON /cart/add.js then /cart.
  function navigateAddToCart(items) {
    items = (items || []).filter(function (it) {
      return it && it.id && !isNaN(Number(it.id)) && Number(it.quantity) > 0;
    });
    if (!items.length) throw new Error('Pick a stand option first.');

    if (items.length === 1) {
      window.location.assign(
        cartUrl('cart/add') +
          '?id=' +
          encodeURIComponent(items[0].id) +
          '&quantity=' +
          encodeURIComponent(items[0].quantity || 1)
      );
      return Promise.resolve();
    }

    var payload = { items: items.map(function (it) {
      return { id: Number(it.id), quantity: Number(it.quantity) || 1 };
    }) };

    return fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    }).then(function (r) {
      return r.text().then(function (text) {
        var data;
        try {
          data = JSON.parse(text);
        } catch (e) {
          throw new Error('Add to cart failed. Try a private window.');
        }
        if (!r.ok) {
          var err = new Error((data && (data.description || data.message)) || 'Add to cart failed');
          err.payload = data;
          throw err;
        }
        window.location.assign(cartUrl('cart'));
      });
    });
  }

  function onAddClick(e) {
    var btn = e.target.closest('button[name="add"], button.product-form__submit, .atc-button');
    if (!btn) return;
    if (btn.closest('.shopify-payment-button')) return;
    // Never intercept checkout / cart update
    if (btn.name === 'checkout' || btn.id === 'checkout' || btn.id === 'CartDrawer-Checkout') return;
    if (btn.classList.contains('cart__checkout-button')) return;
    var form = btn.closest('form');
    if (!form) return;
    if (form.id === 'cart' || form.id === 'CartDrawer-Form') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('cart') === -1 && form.getAttribute('data-type') !== 'add-to-cart-form') return;

    if (inThemeEditor()) {
      e.preventDefault();
      e.stopPropagation();
      alert('Cart doesn’t work inside the theme editor. Open quickrate.store (View store) and test there.');
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    btn.disabled = true;
    fetchProductJs()
      .then(function () {
        enableVariantInputs(form);
        syncMasterIdFromPack(form);
        var section = form.closest('.shopify-section, .featured-product, product-info, .product') || document;
        var packInfo = getSelectedPack(section);
        var idInp = form.querySelector('input[name="id"]');
        var qtyInp = form.querySelector('input[name="quantity"]');
        var fallbackId = idInp && idInp.value;
        var fallbackQty = qtyInp && qtyInp.value ? parseInt(qtyInp.value, 10) : 1;
        var items = buildCartItems(packInfo, fallbackId, fallbackQty);
        return navigateAddToCart(items);
      })
      .catch(function (err) {
        console.error('[quickrate-cart-fix]', err, err && err.payload);
        btn.disabled = false;
        alert(
          (err && err.payload && (err.payload.description || err.payload.message)) ||
            (err && err.message) ||
            'Could not add to cart'
        );
      });
  }

  function bind() {
    enableVariantInputs(document);
    // ONLY touch product add-to-cart forms — never the cart page / drawer form.
    // Rewriting #cart action to /cart/add caused checkout to POST /fr/cart/add
    // → "Required parameter missing or invalid: items"
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
      form.setAttribute('action', cartUrl('cart/add'));
      syncMasterIdFromPack(form);
    });
    // If a cart form was already corrupted by an older fix, restore it
    document.querySelectorAll('form#cart, form#CartDrawer-Form').forEach(function (form) {
      var action = form.getAttribute('action') || '';
      if (/cart\/add/i.test(action)) {
        form.setAttribute('action', cartUrl('cart'));
      }
    });
  }

  document.addEventListener('click', onAddClick, true);
  document.addEventListener('change', function (e) {
    if (!e.target) return;
    if (
      e.target.matches('.quantity-break__variant-select') ||
      e.target.matches('input[type="radio"]') ||
      (e.target.closest && e.target.closest('quantity-breaks'))
    ) {
      var form =
        (e.target.getAttribute && e.target.getAttribute('form') && document.getElementById(e.target.getAttribute('form'))) ||
        document.querySelector('form[data-type="add-to-cart-form"]');
      syncMasterIdFromPack(form);
      enableVariantInputs(form || document);
    }
  });

  bind();
  document.addEventListener('DOMContentLoaded', bind);
  setInterval(bind, 2000);
})();
